import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const Component = ({ options }) => {
    return <HighchartsReact options={options} highcharts={Highcharts} />;
};

export default Component;